import type { EncodedStateAndProps } from './load-utils';

/**
 * Serialises an encoded viewer state/props pair into the viewer-pose string.
 *
 * Lives in its own module rather than in `./load-utils` because `CADViewer.js` — an
 * eagerly-loaded app module — needs only this `JSON.stringify`, while `load-utils`
 * reaches three.js via `Vector3`, `STEPBody` and `STLBody`. Importing it from there
 * put the whole engine in the app's initial chunk. Re-exported from `./load-utils`
 * so existing callers are unaffected.
 *
 * The type import above is erased at compile time, so this module stays three-free
 * despite naming a type that lives beside the engine.
 */
export const encodeViewerPose = (
  encodedViewerState: EncodedStateAndProps['encodedViewerState'],
  encodedViewerProps: EncodedStateAndProps['encodedViewerProps'],
): string => {
  return JSON.stringify({
    es: encodedViewerState,
    ep: encodedViewerProps,
  });
};
